import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.page.html',
  styleUrls: ['./privacy.page.scss'],
})
export class PrivacyPage implements OnInit {

  headerBranding: String;

  constructor (public httpClient: HttpClient,
    private configService: ConfigService) {}

  async ngOnInit() {
    let res = await this.configService.getConfiguration();
    this.headerBranding = res["headerBranding"];
  }

}
